export default __webpack_public_path__ + "static/media/banner-hpc.6041d4ac.jpg";